import { useEffect, useState } from "react";
import { connect } from "react-redux";
import ReactSelect from "react-select";

import { camelCase } from "lodash";
import { DisconnectButton, IntegrationConnectionHandler } from "../IntegrationComponents";
// import { IntegrationImportSchemes } from "./AccountingIntegrationComponents";
import { Actions as ACCOUNTING_INTEGRATION_ACTIONS } from "./store/accountingIntegrationActions";

const AccountingIntegrationSettings = ({
	logo,
	integration,
	// connected = true,
	connected,
	status,
	connect,
	verifyConnection,
	disconnect,
	save,
	settings,
	disabled,
	importAccountingCategoriesAndCostCenters,
	importingAccountingCategoriesAndCostCenters,
	pensionPayScheduleOptions,
	paySchedules,
	saving,
	getOngoingPolls,
	closePollModal,
	pollActionModal,
	handlePollAction,
	onGoingPolls,
	functionality,
	statusMessages,
	currency,
	companyPayPeriods,
	isComingSoon,
	getSchemes,
}) => {
	const [expand, setExpand] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [data, setData] = useState({});

	useEffect(() => {
		if (!connected && expand) setExpand(false);
	}, [connected, expand]);

	useEffect(() => {
		setData(settings || {});
	}, [JSON.stringify(settings)]);

	const updateSetting = ({ category, field, value }) => {
		setData({
			...data,
			[category]: {
				...data?.[category],
				[field]: value,
			},
		});
	};
	// used to mark expanded so we fetch company and accounts data once
	useEffect(() => {
		if (!expanded && expand) {
			setExpanded(true);
		}
	}, [expand]);

	// TODO get information on whether this integration supports multi-company and multi-accounts to avoid these requests
	// fetches all companies linked with this pension integration
	// useEffect(() => {
	// 	if (expanded && !settings?.companies) {
	// 		getCompanies(integration);
	// 	}
	// }, [integration, expanded]);

	return (
		<div className={`${expand ? "tr-gray " : ""} col-xs-12 integration-row`}>
			<div className="col-xs-3">
				<img
					src={logo}
					width="40px"
					alt={`${integration} logo`}
				/>
				<span style={{ paddingLeft: 20, fontSize: 16 }}>{integration}</span>
			</div>
			<div className="col-xs-9">
				<IntegrationConnectionHandler
					functionality={functionality}
					connected={connected}
					isComingSoon={isComingSoon}
					status={status}
					connect={connect}
					statusMessages={statusMessages}
					verifyConnection={verifyConnection}
					disconnect={disconnect}
					setExpand={() => setExpand(!expand)}
					expand={expand}
				/>
			</div>
			<div className="clearfix" />
			{expand && connected ? (
				<>
					<div className="px-6">
						<div className="col-xs-3 pl-0 mt-4"></div>
						<div className="col-xs-9 px-0 pt-3 flex justify-end items-start">

                            <button
                                style={{ marginRight: "2rem" }}
                                className="btn btn-success pull-right"
                                onClick={() => {
                                    importAccountingCategoriesAndCostCenters();
                                }}
                                disabled={importingAccountingCategoriesAndCostCenters}
                            >
                                Import & Sync Accounting Categories & Cost Centers
                            </button>
							<DisconnectButton
								connected={connected}
								disconnect={disconnect}
							/>
						</div>
					</div>
					<div className="clearfix" />
				</>
			) : null}
		</div>
	);

	// TODO add expandable options for selecting a Company and an Account
};

const mapStateToProps = (state, ownProps) => {
	const { integration } = ownProps;

	const settings = state?.integration?.accounting?.[camelCase(integration)];
	const { functionality, logo, isComingSoon } = state?.integrationDetails?.accounting?.[camelCase(integration)] || {};

	return {
		connected: !!settings,
		functionality,
		logo,
		isComingSoon,
		pollActionModal: settings?.pollActionModal,
		settings,
		currency: state?.company?.settings?.currency,
		status: settings?.status,
		statusMessages: settings?.statusMessages,
		onGoingPolls: settings?.onGoingPolls,
	};
};

const mapDispatchToProps = (dispatch, { integration }) => ({
	importAccountingCategoriesAndCostCenters: () => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.importAccountingCategoriesAndCostCenters(integration)),
	getSchemes: (query) => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.getSchemes(integration, query)),
	connect: (credentials) => {
		console.log('justbloodyconnect')
		dispatch(ACCOUNTING_INTEGRATION_ACTIONS.connectAccountingIntegration(integration, credentials))
	},
	disconnect: () => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.disconnectAccountingIntegration(integration)),
	verifyConnection: () => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.verifyConnection(integration)),
	save: () => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.save(integration)),
	updateField: (field, value) => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.updateField(integration, field, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountingIntegrationSettings);
